import React, { ChangeEvent } from 'react';
import { useTranslation } from 'react-i18next';
import { Tooltip } from '@components-library/Tooltip';
import { SelectorCreateButton } from '@components-shared/forms/ExtendedSelectors/SelectorCreateButton';
import styles from '@components-shared/forms/ExtendedSelectors/groupSelector.module.scss';
import { IGroupSelectorProps } from '@components-shared/forms/ExtendedSelectors/types';
import { SelectorBody } from '@components-shared/forms/Select/SelectorBody';
import { ErrorLabel } from '@components-shared/forms/errorLabel';
import { KeyMapKeys, keyMap } from '@locales/lokalise/keyMap';
import cn from 'classnames';

export const ExtendedSelectorsBody = ({
  required,
  valid,
  validationMessage,
  className,
  createButtonProps,
  name,
  value,
  hideChooseText,
  tooltip,

  groupTitle,
  groupItemList,
  onGroupChange,
  groupSelectedValue,
  groupAttributes,
  groupByDefault,

  title,
  onSelectedGroupOptionsChange,
  selectedGroupOptionsAttributes,
  selectedGroupItemList,
}: IGroupSelectorProps & {
  onGroupChange: (e: ChangeEvent<HTMLSelectElement>) => void;
  onSelectedGroupOptionsChange?: (e: ChangeEvent<HTMLSelectElement>) => void;
  groupSelectedValue: string;
}) => {
  const { i18n } = useTranslation();

  return (
    <div data-fieldname={name} className={cn('form__fieldset', styles.groupSelector, className)}>
      <div className="form__field">
        <div className="form__field-container">
          {!valid && validationMessage && <ErrorLabel message={validationMessage} />}
        </div>
        <div className={styles.groupSelector__wrapper}>
          {Array.isArray(groupItemList) && groupItemList.length && !groupByDefault ? (
            <div className="form__select-wrapper">
              <div className="form__label">
                {groupTitle && <span>{i18n.t(groupTitle as KeyMapKeys)}</span>}
                {required && <span className="form__required">*</span>}
                {tooltip && <Tooltip content={tooltip} />}
              </div>
              <SelectorBody
                valid={valid}
                onChange={onGroupChange}
                attributes={groupAttributes}
                defaultSelectOption={`-- ${i18n.t(keyMap.formsChoose)} -- `}
                options={groupItemList}
                hideChooseText={hideChooseText}
                value={groupSelectedValue}
              />
            </div>
          ) : null}
          <div className="form__select-wrapper">
            <div className="form__label">
              {title && <span>{i18n.t(title as KeyMapKeys)}</span>}
              {required && <span className="form__required">*</span>}
            </div>
            <SelectorBody
              value={value}
              onChange={onSelectedGroupOptionsChange}
              attributes={selectedGroupOptionsAttributes}
              valid={valid}
              defaultSelectOption={`-- ${i18n.t(keyMap.formsChoose)} -- `}
              options={selectedGroupItemList}
            />
          </div>
        </div>
        <div className={styles.groupSelector__button}>
          {createButtonProps && (
            <SelectorCreateButton
              name={createButtonProps.buttonName}
              changeStepHandle={createButtonProps.onChangeHandler}
            />
          )}
        </div>
        <div className={styles.groupSelector__divider} />
      </div>
    </div>
  );
};
